import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddTeam from "./ModalAddTeam";

const useModalAddTeam = ( onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, team_id: null, mode: 'none', organisation_id: null })  ;

    const onClickActivate = ( newMode,  organisation_id, team_id, ) =>
    {
        switch ( newMode )
        {
            case 'delete':
                setDialog ({ openState: true, team_id: team_id, mode: 'delete', organisation_id: organisation_id});
                break ;
            case 'create':
                setDialog ({ openState: true, team_id: team_id, mode: 'create', organisation_id: organisation_id});
                break ;
            case 'edit':
                setDialog ({ openState: true, team_id: team_id,  mode: 'edit', organisation_id: organisation_id});
                break ;
        }
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, team_id: null, key: null, mode: 'none', organisation_id: null});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, team_id: null, mode: 'none', organisation_id: null});
        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddTeam team_id={dialog.team_id} organisation_id={dialog.organisation_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddTeam ;
